import vuetify from '@/plugins/vuetify/index';
import { useUserStore } from '@/stores/user.state.js';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import i18n from './plugins/i18n';

import App from './App.vue';
import router from './router';

const app = createApp(App);

app.use(VueTelInput as any);
app.use(createPinia());
app.component('Editor', QuillEditor);
app.use(router).use(vuetify).use(i18n);

router.beforeEach((to, _from, next) => {
  if (to.meta.requiresAuth) {
    const userStore = useUserStore();
    if (!userStore.isLoggedIn) next({ name: 'login' });
    else next();
  } else if (to.name == 'login') {
    const userStore = useUserStore();
    if (userStore.isLoggedIn) next({ name: 'dashboard' });
    else next();
  } else next();
});

app.mount('#app');
